import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { RouteTrackingService } from '@service/routeTracking/route-tracking.service';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { filter } from 'rxjs/operators';
import { IntercomService } from '@service/intercom/intercom.service';
import { UtilService } from '@service/util/util.service';
import { CARGOCHIEF_KEYS } from '@domain/constants/app-variables';
import { Store } from '@ngrx/store';
import { SessionActions, sessionStateKey } from '@state/session';

declare const FingerprintJS: any;
declare const window: any;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
	isLazyLoadingRouterModule: boolean = false;

	constructor(
		private cargoChief: Cargochief,
		private router: Router,
		private routeTrack: RouteTrackingService,
		private intercomService: IntercomService,
		private utilService: UtilService,
		private renderer: Renderer2,
		private store: Store
	) {
		this.detectBrowser();
		if (window.location.href.indexOf('/#!/register') > 0) {
			window.location.href = window.location.href.replace('/#!/', '/#/');
		}
		const vm = this;
		if (this.cargoChief.getDeviceId() == undefined || this.cargoChief.getDeviceId() == null) {
			setTimeout(() => {
				FingerprintJS.load()
					.then((fp) => fp.get())
					.then((result) => localStorage.setItem('deviceId', result.visitorId));
			}, 500);
		}
	}

	@HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
		localStorage.setItem('isForegroundEnabled', 'false');
	}

	detectBrowser() {
		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
				if (isIEOrEdge) {
					this.router.navigate(['change_browser']);
				}
			});
	}

	ngOnInit() {
		this.cargoChief.removeItem(CARGOCHIEF_KEYS.LOGGED_IN);
		this.router.events.subscribe((event) => {
			if (event instanceof RouteConfigLoadStart) {
				this.cargoChief.removeItem(CARGOCHIEF_KEYS.NEXT_PAYMENT_DATE_EXPIRED);
				this.isLazyLoadingRouterModule = true;
			} else if (event instanceof RouteConfigLoadEnd) {
				if (
					!this.utilService.isNullOrUndefined(this.cargoChief.getUser()) &&
					!this.utilService.isAccountTypeAdmin()
				) {
					this.intercomService.bootAndShow();
				}
				this.isLazyLoadingRouterModule = false;
			}
		});

		this.renderer.listen('window', 'storage', (event) => {
			if (event.key === sessionStateKey) {
				this.store.dispatch(SessionActions.storage.update());
			}
		});
	}
}
